module.exports = __webpack_public_path__ + "img/logo2.1724e0ea.png";